var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataForPayment)?_c('PaymentModal',{attrs:{"dataForPayment":_vm.dataForPayment},on:{"close":function($event){_vm.dataForPayment = null}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }